import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';
import EmployeeOffers from '../../../components/EmployeeOffers';
import Collapse from '@mui/material/Collapse';


/**
 * Views menu for Employee
 * @param {{
 *  classes: *;
 * }} param0 
 */
const Views = ({
    classes,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation('employmentBillboard', { keyPrefix: "billboard" });
    
    return (
        <div>
            <hr />
            <div className={classes?.filterTitle} onClick={() => setIsOpen(!isOpen)}>
                {t('views')}
                <FontAwesomeIcon 
                    icon={isOpen ? faAngleUp : faAngleDown}
                    style={{ float: "right", marginRight: "10px" }}
                />
            </div>
            <Collapse
                in={isOpen}
                timeout={{ enter: 750, exit: 750 }}
                style={{ transitionDelay: "250ms" }}
            >
                <EmployeeOffers />
            </Collapse>
        </div>
    );
};

export default Views;
